import styled from "styled-components";

export const ContentContainer = styled.div`
    padding: 1em;
`